import { skipToken } from "@reduxjs/toolkit/query";
import { useGetUserSettingsQuery } from "../api/aiChatApi";
import { useHasExopenAiAccess } from "./useHasExopenAiAccess";

export const useOnboardingStatus = (companyDomainId: string) => {
	const hasAccess = useHasExopenAiAccess(companyDomainId);
	const { data: settings, isLoading } = useGetUserSettingsQuery(
		hasAccess ? companyDomainId : skipToken,
	);

	return {
		// WHY fail closed: no settings (fetch failed) must not read as "consent given".
		needsOnboarding:
			hasAccess &&
			!isLoading &&
			(settings === undefined || settings.onboardingCompletedAt === null),
		isLoading: hasAccess && isLoading,
	};
};
